import { render, staticRenderFns } from "./ProjectScope.vue?vue&type=template&id=61556ad2&"
import script from "./ProjectScope.vue?vue&type=script&lang=js&"
export * from "./ProjectScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports